import axios from 'axios';
import API_BASE_URL from '../config.js';

const reservation = async (data) => {

    const response = await axios.post(`${API_BASE_URL}/reservation/`, data
    );
    return response.data;

};

export default reservation;
